/**
 * Auto-focus first input when any Bootstrap modal is shown (desktop only).
 * This improves UX by allowing users to start typing immediately.
 *
 * Disabled on mobile to avoid opening the keyboard involuntarily,
 * which would hide content and shift the modal position.
 *
 * To disable autofocus on a specific modal, add data-no-autofocus attribute:
 * <div class="modal" data-no-autofocus>...</div>
 */
const focusFirstInput = (modalElement) => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
        return;
    }

    if (modalElement?.hasAttribute('data-no-autofocus')) {
        return;
    }

    const input = modalElement?.querySelector('input:not([type="hidden"]):not([readonly]):not([disabled])');
    input?.focus();
};

// Bootstrap modal events bubble up to document.body
document.body.addEventListener('shown.bs.modal', (event) => {
    focusFirstInput(event.target);
});

// Support for modals with HTMX-loaded content
document.body.addEventListener('htmx:afterSwap', (event) => {
    const modal = event.target.closest('.modal.show');
    if (modal) {
        focusFirstInput(modal);
    }
});
